import React from "react";
import styled from "@emotion/styled";
import { ThemeContext } from "../../contexts/Context";
import { DialogBackdrop, DialogCard, DialogDescription, DialogActions, DialogButton } from "./ConfirmCheckoutModal";

const Modal = ({ show, setShow, error = [], fontFamily }) => {
  const theme = React.useContext(ThemeContext);
  if (!show) return null;
  if (fontFamily) return <MemberBackdrop>
    <MemberCard fontFamily={fontFamily} role="alertdialog" aria-modal="true" aria-label={error.map(item => item.errorMessage).join(" ")} onKeyDown={event => { if (event.key === "Escape") setShow(false); }}>
      {error.map((item, index) => <MemberMessage key={index}>{item.errorMessage}</MemberMessage>)}
      <MemberButton autoFocus type="button" onClick={() => setShow(false)}>OK</MemberButton>
    </MemberCard>
  </MemberBackdrop>;
  return <DialogBackdrop>
    <DialogCard themeContext={theme} style={fontFamily ? { fontFamily } : undefined} role="alertdialog" aria-modal="true" aria-label={error.map(item => item.errorMessage).join(" ")} onKeyDown={event => { if (event.key === "Escape") setShow(false); }}>
      {error.map((item, index) => <DialogDescription key={index}>{item.errorMessage}</DialogDescription>)}
      <DialogActions><DialogButton autoFocus type="button" primary themeContext={theme} onClick={() => setShow(false)}>OK</DialogButton></DialogActions>
    </DialogCard>
  </DialogBackdrop>;
};
export default Modal;

// Member screens retain their established typography and spacious warning layout.
const MemberBackdrop = styled(DialogBackdrop)`
  background: rgba(0, 0, 0, .6);
`;
const MemberCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  width: 92%;
  max-width: 630px;
  min-height: 290px;
  padding: 48px 34px 34px;
  border: 2px solid #a8a8a8;
  border-radius: 28px;
  background: #fff;
  color: #211513;
  font-family: ${p => p.fontFamily};
  font-size: 26px;
  font-weight: 300;
  @media (max-width: 390px) {
    min-height: 250px;
    padding: 40px 24px 28px;
  }
`;
const MemberMessage = styled.div`
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: 300;
  line-height: 1.42;
  word-break: break-word;
  @media (max-width: 390px) { font-size: 25px; }
`;
const MemberButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 54px;
  min-width: 140px;
  min-height: 48px;
  padding: 12px 48px;
  box-sizing: border-box;
  background: transparent;
  color: #211513;
  border: none;
  border-radius: 8px;
  font: inherit;
  font-size: 54px;
  font-weight: 300;
  line-height: 1;
  cursor: pointer;
  @media (max-width: 390px) { font-size: 46px; }
`;
